import { DatalayerHelper } from './ib-datalayer-helper';
import * as ancillariesInfo   from '../core/models/ancillaries-info';

@Service('ib-web-ancillaries-module',
    ['CommonsUtilService', 'localStorageService', 'AncillariesConstants', 'DatalayerHelper'],
    ['ib-commons-constants-module', 'ib-monetate-module'])
export class BundlesDatalayerUtils {
    seatSelectedId: string[] = [];
    seatSelectedType: string[] = [];
    segmentId: string;
    constructor (
        private CommonsUtilService: CommonsUtilService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesConstants: AncillariesConstant,
        private DatalayerHelper: DatalayerHelper
    ) { }

    getDataEcommerceForBundle (bundle) {
        const id = this.CommonsUtilService.getIdItem('all');
        const selectedTripInfo: any = this.localStorageService.get('selectedTripInfo');
        const item: DigitalDataEcommerceModel.Item = {
            item_name: this.AncillariesConstants.DATALAYER_INFO.BUNDLE,
            item_id: id,
            price: bundle.allDiscountByPassAndSlice,
            item_brand: selectedTripInfo ? selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase() : this.DatalayerHelper.getBrandItem(id, null),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: 'all',
            item_category3: 'all',
            item_variant: bundle.id
        };
        return item;
    }
}

